import * as React from "react";
import ReactTable from "react-table";
import {Documento} from "../../documentos/modelo/Documento";
import { FiltroReporte } from "../modelo/Reporte";
import {EstadoTarea} from "../../bandeja/modelo/EstadosTarea";

export default class TablaReportes extends React.Component<TablaReportesEmpresasProps> {

    columns = [{
        Header: "Identificación",
        accessor: "afiliado.identificacion",
    }, {
        Header: "Nombre Legal",
        accessor: "afiliado.nombreLegal",
    }, {
        Header: "Fecha Radicación",
        accessor: "fechaRadicacion",
    }, {
        Header: "Estado",
        accessor: "estado",
        width: 260
    },{
        Header: "Poliza - Inicio Cobertura",
        accessor: "poliza",
        Cell: props => (
            <div className={"text-center"}>
                {this.renderFechaCobertura(props)}
            </div>
        )
    }, {
        Header: "Tipo Cliente",
        accessor: "tipoCliente.nombre",
    }];

    render() {
        const {documentos,paginas, tamanoPagina, paginaActual} = this.props;

        let numRegistros = 0;
        if (documentos.length < tamanoPagina) {
            numRegistros = documentos.length;
        } else {
            numRegistros = tamanoPagina;
        }
        return (
            <div className={"panel panel-success"}>
                <div className={"panel-heading"}>
                    <h2 className={"panel-title-white"}>
                        <span className="badge">{documentos.length}</span> Documentos encontrados
                    </h2>
                </div>
                <ReactTable data={documentos}
                            columns={this.columns}
                            manual
                            defaultPageSize={numRegistros}
                            pageSizeOptions={this.calcularOpciones(numRegistros)}
                            page={paginaActual}
                            sortable={false}
                            previousText={"Anterior"}
                            nextText={"Siguiente"}
                            loadingText={"Cargando..."}
                            noDataText={"No se ha encontrado información."}
                            pageText={"Página"}
                            ofText={"de"}
                            rowsText={""}
                            className={"-highlight -striped"}
                            pages={paginas}
                            onPageChange={(pageIndex) => {
                                this.consultarCambioPagina(tamanoPagina, pageIndex, tamanoPagina);
                            }}
                            onPageSizeChange={(pageSize, pageIndex) => {
                                this.consultarCambioPagina(pageSize, pageIndex, tamanoPagina);
                            }}
                />
            </div>
        );
    }

    consultarCambioPagina(pageSize: number, pageIndex: number, tamanoPagina: number) {
        
        const filtroReporte: FiltroReporte = {
            oficina: this.props.filtroReporte.oficina,
            tipoCliente: this.props.filtroReporte.tipoCliente,
            estado: this.props.filtroReporte.estado,
            fechaInicio: this.props.filtroReporte.fechaInicio,
            fechaFin: this.props.filtroReporte.fechaFin,
            fechaInicioAprobacion: this.props.filtroReporte.fechaInicioAprobacion,
            fechaFinAprobacion: this.props.filtroReporte.fechaFinAprobacion,
            tipoTramite: this.props.filtroReporte.tipoTramite,
            registrosPorPagina: pageSize ? pageSize : tamanoPagina,
            pagina: pageIndex,
        };
        this.props.consultaPaginada(filtroReporte);
    }

    calcularOpciones(tamanoPagina : number) {
        const arreglo = [10, 20, 25, 50, 100];
        const elemento = arreglo.find(valor => valor === tamanoPagina);
        if( elemento ) {
            return arreglo;
        } else {
            return [...arreglo,tamanoPagina].sort( (a, b) => {return a-b;} );
        }
     }

    renderFechaCobertura = (props: any) => {
        if(props.original.estado === EstadoTarea.aprobado) {
            return(`${props.value} - ${props.original.fechaInicioCobertura}`);
        } else { 
            return (``);
        }
    }

}

interface TablaReportesEmpresasProps {
    documentos: Array<Documento>,
    filtroReporte: FiltroReporte,
    paginas: number,
    tamanoPagina: number,
    paginaActual: number,
    consultaPaginada?: (filtroReporte: FiltroReporte) => void
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/reportes/componentes/TablaReportesEmpresas.tsx